import React, { FC, PropsWithChildren } from "react";
import styled from "@emotion/styled";
import { Box } from "@mui/material";

const Title = styled.div`
  font-size: 20px;
  line-height: 30px;
  font-weight: 600;
  color: #171a1fff;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 12px;
`;

const OnboardingFormSection: FC<
  PropsWithChildren<{ title: string; marginTop?: boolean }>
> = ({ children, title, marginTop = true }) => {
  return (
    <Box marginTop={marginTop ? "40px" : "0"}>
      <Title>{title}</Title>
      {children}
    </Box>
  );
};

export default OnboardingFormSection;
